/**
 * 新建 or 编辑问题
 */
import React, {useState, useEffect, useReducer, useRef} from 'react';
import {
  Form,
  Button,
  Select,
  Row,
  Col,
  message,
  Input,
  DatePicker,
  Spin,
  ConfigProvider,
  TreeSelect,
  Upload,
  Modal,
} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import {
  convertListToTree,
  filterSerchData,
  formatToTree,
  momentFormData,
  propsDragger,
} from '@/utils/common';
import zhCN from 'antd/lib/locale/zh_CN';
import {modalSearchFn} from './searchList';
import {isObject} from 'lodash-es';
import {CloseCircleOutlined} from '@ant-design/icons';
import {SFuncModal, SDrawerOrModal} from "shj-components";
import {getFileUrlPrefix} from "@/services";
import {iiHOC} from "@/utils/auth.ts";
import arrToListOption from "@/pages/homePage/components/addMatter";
import {CheckThePhoneInp} from "@/pages/homePage/components/addClue";
import dayjs from "dayjs";
import {
  getCustomerSource, getTicketsChannelConfig,
  getTicketsExposureConfig,
  getTicketsInternalConfig,
  ticketsIssueDetail, ticketsIssueSaveOrUpdate
} from "@/services/customerServices.ts";
import {getEnums, httpOrgList} from "@/services/homeService.ts";

const {Option} = Select;
const {TextArea} = Input;

export const ModalAddMatterTab = (props: any) => <ModalAddMatterDom {...props} />;

export const ModalAddMatterFn = (val: any) => {
  return (
    <>
      <ConfigProvider locale={zhCN}>
        <ModalAddMatterDom onClose={val?.onClose || (() => ({}))} {...val} />
      </ConfigProvider>
    </>
);
}

export const ModalAddMatterDom = (params: any) => {
  const {onClose, fn, id, issueId, isEdited, formOnly, open = false} = params;
  const formNode = useRef<any>();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isSpecial, setIsSpecial] = useState(false);
  const [spinLoading, setSpinLoading] = useState(false);
  const [fileList, setFileList] = useState([]); // 文件存放地址
  const [customerInfo, setCustomerInfo] = useState({});
  const [_fullPhone, _setFullPhone] = useState('');
  const [_fullBackPhone, _setFullBackPhone] = useState('');
  const [detailData, setDetailData] = useState({});
  const [baseUrl, setBaseUrl] = useState<any>('');

  const onChange = (newValue: string) => {
    setClassifyId(newValue);
  };

  const [state, dispatch] = useReducer(
      (state, action) => {
        return action;
      },
      {
        channelConfig: [],
        exposureConfig: [],
        issueTypeEnum: [],
        companyList: [],
        orderIssueLevelEnum: [],
        channelTree: [],
      },
  );
  useEffect(() => {
    initFn();
  }, []);
  const initFn = async () => {
    setSpinLoading(true);
    const baseUrl = await getFileUrlPrefix();
    setBaseUrl(baseUrl);
    if (isEdited) {
      const data = await Promise.all([ticketsIssueDetail(issueId)]);
      const _orderIssueList = data[0] || {};

      let ourFiles = _orderIssueList?.files && JSON.parse(_orderIssueList['files']);
      ourFiles =
          _orderIssueList?.files &&
          ourFiles.map((val: any, index: any) => {
            return {
              uid: index,
              name: val.name,
              status: 'done',
              url: val.path,
              path: val.path,
              type: val.type,
            };
          });
      setFileList(ourFiles || []);

      let _customerInfo = data[0]?.customerInfo;
      _customerInfo = momentFormData(_customerInfo, [
        'handoverDate',
        'planStartDate',
        'planEndDate',
        'actualStartDate',
        'actualEndDate',
        'disclosureDate',
      ]);
      _customerInfo['remoteSite'] =
          _customerInfo?.remoteSite == 1 ? 'true' : _customerInfo?.remoteSite == 0 ? 'false' : '';
      _customerInfo['visual'] = _customerInfo?.visual == 1 ? 'true' : _customerInfo?.visual == 0 ? 'false' : '';
      form.setFieldsValue({
        ...data[0],
        typeId: String(data[0]?.typeId),
        levelId: String(data[0]?.levelId),
        ..._customerInfo,
        ...{name: _customerInfo['name'], customerId: _customerInfo['id']},
        ...{file: ourFiles || []},
      });

      setDetailData({...data[0], ...data[0].customerInfo});
      console.log({...data[0], ...data[0].customerInfo})
      setSpinLoading(false);
    }

    return new Promise((resolve, reject) => {
      Promise.all([
        httpOrgList(),
        getCustomerSource(),
        getTicketsExposureConfig({data: {}}),
        getTicketsInternalConfig({data: {}}),
        getTicketsChannelConfig({data: {}}),
        getEnums('plus-crm', 'com.shj.saas.plus.crm.domain.tickets.enums.OrderIssueTypeEnum'),
        getEnums('plus-crm', 'com.shj.saas.plus.crm.domain.tickets.enums.OrderIssueLevelEnum'),
      ])
          .then((resp) => {
            const listObj = {
              companyList: [...resp[0]],
              channelTree: resp[1],
              exposureConfig: convertListToTree(resp[2],{pid: 'parentId'}),
              internalConfig: convertListToTree(resp[3],{pid: 'parentId'}),
              channelConfig: convertListToTree(resp[4],{pid: 'parentId'}),
              issueTypeEnum: resp[5],
              orderIssueLevelEnum: resp[6],
            };
            dispatch(listObj);
          })
          .catch((err) => {
            setSpinLoading(false);
          });
      setSpinLoading(false);
    }).catch((err) => {
      setSpinLoading(false);
    });
  };

  const btnStatus = (otherStatus: boolean) => {
    if (isSpecial) {
      return false;
    }
    return otherStatus;
  };

  const onFinish = (values: any) => {
    if (loading) return;
    form.validateFields().then(values => {
      setLoading(true);
      let ourParams = {
        ...values,
        ...filterSerchData({...values}, [
          'handoverDate',
          'planStartDate',
          'planEndDate',
          'actualStartDate',
          'actualEndDate',
          'disclosureDate',
        ]),
      };
      Object.keys(ourParams).map((v) => {
        if (isObject(ourParams[v])) {
          ourParams[v] = ourParams[v].toString();
        }
      });
      ourParams = {
        ...ourParams,
        classifyIds: ourParams.classifyIds.split(','),
        ...{
          customerInfo: {
            id: values.customerId,
            ...customerInfo,
            ...ourParams,
            ...{bizOpId: customerInfo?.id},
            ...{phoneEncode: customerInfo?.phoneEncode || detailData?.phoneEncode},
            // ...{remoteSite: ourParams.remoteSite == 'true' ? 1 : ourParams.remoteSite == 'false' ? 0 : null},
            // ...{visual: ourParams.visual == 'true' ? 1 : ourParams.visual == 'false' ? 0 : null},
          },
        },
        ...{id: isEdited ? issueId : ''},
        ...{feedbackPhoneEncode: detailData?.feedbackPhoneEncode || ''},
        ...{file: fileList},
      };
      ticketsIssueSaveOrUpdate(ourParams).then((resp: any) => {
          message.success(resp.message || '操作成功');
          fn && fn();
          onClose();
        })
        .finally(() => {
          setLoading(false);
        });
    })
  };
  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };
  const {channelConfig, exposureConfig, issueTypeEnum, companyList, orderIssueLevelEnum, channelTree, internalConfig} = state;
  return iiHOC(
      <SDrawerOrModal
        title={params?.isEdited ? `编辑问题` : `新建问题`}
        width={1000}
        onCancel={onClose}
        onOk={onFinish}
        loading={loading}
        open={open}
        mode='drawer'
      >
        <Spin spinning={spinLoading} tip="加载中...">
          <Form
              ref={formNode}
              form={form}
              {...{
                labelCol: {
                  xs: {span: 18},
                  sm: {span: 12},
                },
                wrapperCol: {
                  xs: {span: 18},
                  sm: {span: 20},
                },
              }}
              layout='vertical'
          >
            <Row gutter={2}>
              <Col span={12}>
                <Form.Item name={'customerId'} hidden><Input/></Form.Item>
                <Form.Item label="来源" name="channelId" required rules={[{required: true, message: '请选择'}]}>
                  <TreeSelect
                      fieldNames={{label: 'name', value: 'id'}}
                      dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                      placeholder="请选择"
                      treeDefaultExpandAll
                      onChange={(newValue, item, node) => {
                        form.setFieldsValue({levelId: node?.triggerNode?.props?.levelId?.toString()});
                        formNode?.current?.setFieldsValue({channelId: newValue});
                      }}
                      treeData={channelConfig}
                      showSearch={true}
                      allowClear
                      filterTreeNode={(inputValue: any, treeNode: any) => {
                        console.log('treeNode---->', treeNode)
                        return treeNode.name.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
                      }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="类型" name="typeId" required rules={[{required: true, message: '请选择'}]}>
                  <Select
                      disabled={btnStatus(false)}
                      placeholder="请选择"
                      allowClear
                      fieldNames={{label: 'description', value: 'key'}}
                      options={issueTypeEnum}
                      showSearch
                      optionFilterProp={'description'}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="提起曝光渠道" name="exposureId">
                  <TreeSelect
                      fieldNames={{label: 'name', value: 'id'}}
                      dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                      placeholder="请选择"
                      treeDefaultExpandAll
                      onChange={(newValue, item, node) => {
                        formNode?.current?.setFieldsValue({exposureId: newValue});
                      }}
                      treeData={exposureConfig}
                      showSearch={true}
                      allowClear
                      filterTreeNode={(inputValue: any, treeNode: any) => {
                        return treeNode.name.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
                      }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="分类" name="classifyIds" required rules={[{required: true, message: '请选择'}]}>
                  <TreeSelect
                      fieldNames={{label: 'name', value: 'id'}}
                      showSearch={true}
                      dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                      placeholder="请选择"
                      allowClear
                      multiple
                      maxTagCount={1}
                      treeData={internalConfig}
                      filterTreeNode={(inputValue: any, treeNode: any) => {
                        return treeNode.name.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0;
                      }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="客户名称" name="name" required rules={[{required: true}]}>
                  <Input
                      allowClear
                      placeholder="请输入"
                      style={{width: '100%'}}
                      /*  onChange={() => {
                          setCustomerInfo({});
                        }}*/
                      /*  addonAfter={
                          <div style={{display: 'flex', justifyContent: 'space-between'}}>
                            <div
                                style={{
                                  width: '120%',
                                  height: '100%',
                                  cursor: 'pointer',
                                  borderRight: 'px solid #eee',
                                  textAlign: 'center',
                                }}
                                onClick={() => {
                                  modalSearchFn({
                                    fn: (val) => {
                                      let _customerInfo = {
                                        ...val,
                                        ...val.completionPeriodInfo,
                                        ...val.underConstructionPeriodInfo,
                                      };
                                      _customerInfo = momentFormData(_customerInfo, [
                                        'handoverDate',
                                        'planStartDate',
                                        'planEndDate',
                                        'actualStartDate',
                                        'actualEndDate',
                                        'disclosureDate',
                                      ]);
                                      form.setFieldsValue({
                                        ..._customerInfo,
                                        ...{
                                          name: _customerInfo.name,
                                          companyId: _customerInfo.companyCode, //所属门店
                                          feedPhone: _customerInfo.phone, //签约电话
                                        },
                                      });
                                      setCustomerInfo(_customerInfo);
                                    },
                                  });
                                }}
                            >
                              选择客户
                            </div>
                            <div style={{width: '10%', cursor: 'pointer', textAlign: 'center'}}>
                              <CloseCircleOutlined
                                  onClick={() => {
                                    form.setFieldsValue({
                                      name: '',
                                      companyId: null,
                                      phone: '',
                                      stateDisplay: '',
                                      buildingName: '',
                                      houseNumber: '',
                                      projectCode: '',
                                      typeDisplay: '',
                                      designDeptDisplay: '',
                                      designerDisplay: '',
                                      designerManager: '',
                                      deliveryDept: '',
                                      deliveryManager: '',
                                      projectManager: '',
                                      engineeringSupervision: '',
                                      softSteward: '',
                                      feedPhone: '',
                                      handoverDate: '',
                                      planStartDate: '',
                                      planEndDate: '',
                                      actualStartDate: '',
                                      actualEndDate: '',
                                      disclosureDate: '',
                                    });
                                    setCustomerInfo({});
                                  }}
                              />
                            </div>
                          </div>
                        }*/
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="所属门店" name="companyId" required
                           rules={[{required: true, message: '请选择所属门店'}]}>
                  <Select disabled={btnStatus(false)} placeholder="请选择" allowClear options={companyList}
                          fieldNames={{label: 'name', value: 'id'}}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                    label="联系电话"
                    name="feedbackPhone"
                    required
                    rules={[{required: true, message: '请输入联系电话'}]}
                >
                  <Input
                      type="tel"
                      disabled={btnStatus(false)}
                      placeholder="请输入联系电话"
                      style={{width: '100%'}}
                      addonAfter={
                        isEdited ? (
                            <CheckThePhoneInp
                                id={issueId}
                                sysItem={'ISSUE'}
                                param1={'联系电话'}
                                fn={(val: any) => {
                                  if (val == '') {
                                    form.setFieldsValue({feedbackPhone: detailData?.feedbackPhone});
                                  } else {
                                    form.setFieldsValue({feedbackPhone: val});
                                  }
                                }}
                                encodeValue={detailData?.feedbackPhoneEncode}
                            ></CheckThePhoneInp>
                        ) : null
                      }
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="签约电话" name="phone" required rules={[{required: true, message: '请输入签约电话'}]}>
                  <Input
                      type="tel"
                      disabled={btnStatus(false)}
                      placeholder="请输入签约电话"
                      style={{width: '100%'}}
                      addonAfter={
                        isEdited ? (
                            <CheckThePhoneInp
                                id={issueId}
                                sysItem={'ISSUE'}
                                param1={'签约电话'}
                                fn={(val: any) => {
                                  if (val == '') {
                                    form.setFieldsValue({phone: detailData?.phone});
                                  } else {
                                    form.setFieldsValue({phone: val});
                                  }
                                }}
                                encodeValue={detailData?.phoneEncode}
                            ></CheckThePhoneInp>
                        ) : null
                      }
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="状态" name="stateDisplay" required rules={[{required: true, message: '请输入状态'}]}>
                  <Input disabled={btnStatus(false)} placeholder="请输入状态" style={{width: '100%'}}/>
                  {/* <Select disabled={btnStatus(false)} placeholder="请选择" allowClear>
                  <Option value="1">待受理</Option>
                  <Option value="2">处理中</Option>
                  <Option value="4">已处理</Option>
                  <Option value="3">已归档</Option>
                  <Option value="9">不成立</Option>
                </Select> */}
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="楼盘名称" name="buildingName">
                  <Input disabled={btnStatus(false)} placeholder="请输入" style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="房号" name="houseNumber">
                  <Input disabled={btnStatus(false)} placeholder="请输入" style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="项目编号" name="projectCode">
                  <Input disabled={btnStatus(false)} placeholder="请输入" style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="需求类型" name="typeDisplay">
                  <Input disabled={btnStatus(false)} placeholder="请输入" style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="设计部门" name="designDeptDisplay">
                  <Input disabled={btnStatus(false)} placeholder="请输入" style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="设计师" name="designerDisplay">
                  <Input disabled={btnStatus(false)} placeholder="请输入" style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="设计部经理" name="designerManager">
                  <Input disabled={btnStatus(false)} placeholder="请输入" style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="交付部门" name="deliveryDept">
                  <Input disabled={btnStatus(false)} placeholder="请输入" style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="交付经理" name="deliveryManager">
                  <Input disabled={btnStatus(false)} placeholder="请输入" style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="项目经理" name="projectManager">
                  <Input disabled={btnStatus(false)} placeholder="请输入" style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="质检员" name="engineeringSupervision">
                  <Input disabled={btnStatus(false)} placeholder="请输入" style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="软装管家" name="softSteward">
                  <Input disabled={btnStatus(false)} placeholder="请输入" style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="交付日期" name="handoverDate">
                  <DatePicker
                      disabled={btnStatus(false)}
                      style={{width: '100%'}}
                      allowClear
                      showTime={{
                        defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                      }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="计划开工日期" name="planStartDate">
                  <DatePicker
                      disabled={btnStatus(false)}
                      style={{width: '100%'}}
                      allowClear
                      showTime={{
                        defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                      }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="计划完工日期" name="planEndDate">
                  <DatePicker
                      disabled={btnStatus(false)}
                      style={{width: '100%'}}
                      allowClear
                      showTime={{
                        defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                      }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="实际开工日期" name="actualStartDate">
                  <DatePicker
                      disabled={btnStatus(false)}
                      style={{width: '100%'}}
                      allowClear
                      showTime={{
                        defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                      }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="实际竣工日期" name="actualEndDate">
                  <DatePicker
                      disabled={btnStatus(false)}
                      style={{width: '100%'}}
                      allowClear
                      showTime={{
                        defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                      }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="交底日期" name="disclosureDate">
                  <DatePicker
                      disabled={btnStatus(false)}
                      style={{width: '100%'}}
                      allowClear
                      showTime={{
                        defaultValue: dayjs('00:00:00', 'HH:mm:ss'),
                      }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="是否远程工地" name="remoteSite">
                  <Select disabled={btnStatus(false)} placeholder="请选择" allowClear>
                    <Option value={'true'}>是</Option>
                    <Option value={'false'}>否</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="是否可视化工地" name="visual">
                  <Select disabled={btnStatus(false)} placeholder="请选择" allowClear>
                    <Option value={'true'}>是</Option>
                    <Option value={'false'}>否</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="问题级别" name="levelId" required rules={[{required: true, message: '请选择'}]}>
                  <Select disabled={btnStatus(false)} placeholder="请选择" allowClear
                          options={orderIssueLevelEnum}
                          fieldNames={{label: 'description', value: 'key'}}/>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                    label="问题描述"
                    name="description"
                    required
                    rules={[{required: true, message: '请输入'}]}
                    labelCol={{
                      xs: {span: 12},
                      sm: {span: 12},
                    }}
                    wrapperCol={{
                      xs: {span: 20},
                      sm: {span: 22},
                    }}
                >
                  <TextArea disabled={btnStatus(false)} placeholder="请输入" style={{width: '100%'}} maxLength={300} showCount/>
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                    extra="支持扩展名：.rar .zip .doc .docx .pdf .jpg .png .gif"
                    label="上传附件"
                    valuePropName="fileList"
                    getValueFromEvent={normFile}
                    name="file"
                    // rules={[{ required: true, message: '成品上传不能为空' }]}
                    labelCol={{
                      xs: {span: 4},
                      sm: {span: 2},
                    }}
                    wrapperCol={{
                      xs: {span: 20},
                      sm: {span: 22},
                    }}
                >
                  <Upload
                      {...propsDragger({
                        fileList,
                        baseUrl,
                        fn: (val: any) => {
                          console.log(val,'image')
                          setFileList(val);
                        },
                      })}
                      listType="picture-card"
                  >
                    <div>
                      <PlusOutlined/>
                      <div style={{marginTop: 8}}>选择图片</div>
                    </div>
                  </Upload>
                </Form.Item>
              </Col>

            </Row>
          </Form>
        </Spin>
      </SDrawerOrModal>,
  );
};
